import axios from '@api/axios';

const axiosInstance = axios.create({
    baseURL: `/api/profiles`
});

const edit = function(form) {
    return axiosInstance.post('', form);
};

const get = function() {
    return axiosInstance.get('');
};

const toVue = function(db) {
    let local = {};

    local.id = db.id;
    local.firstName = db.first_name;
    local.lastName = db.last_name;
    local.phoneNumber = db.phone_number;
    local.email = db.email;

    if (db.address) {
        local.address = {};
        local.address.line1 = db.address.line_1;
        local.address.line2 = db.address.line_2;
        local.address.postalCode = db.address.postal_code;
        local.address.latitude = db.address.latitude;
        local.address.longitude = db.address.longitude;
        local.address.city = db.address.city;
        local.address.county = db.address.county_id;
    }

    return local;
};

export default { axios: axiosInstance, edit, get, toVue };
